/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:01/05/2022
 @Time:14:17
 **/

import BegroFile from "../BegroFile";
import Societe from "../../../societe/model/Societe";


export default class ImageFile extends BegroFile {

    /**
     * @type {Societe}
     */
    #_societe;


    constructor() {
        super();
        this.baseURL="societe/profil";
    }

    get societe() {
        return this.#_societe;
    }

    set societe(value) {
        this.#_societe = value;
    }

}